
const state = {
  user: {}
}

const getters = {};

const actions = {
  splitNameBeforeSave: ({ commit }, userData) => {
    const nameArr = userData.fullName.split(' ');
    userData.name = nameArr[1];
    userData.secondName = nameArr[0];
    userData.lastName = nameArr[2];
    commit('saveUserData', userData);
  }
}

const mutations = {
  saveUserData: (state, data) => {
    state.user = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
